import type { Action } from 'vuex';
import { ApiError } from '@/api/errors';
import { request } from '@/api/request';

const API_ERROR = 'API_ERROR';
const sleep = (ms: number) =>
  new Promise((r) => {
    setTimeout(r, ms);
  });

const useApi = () => {
  const use = ['test'].includes(import.meta.env.MODE);
  return use;
};

const apiCall: Action<any, any> = async (
  { commit, dispatch },
  {
    url,
    method = 'get',
    options = {},
    request: requestMutation,
    success,
    error,
    globalError = true,
    loading_flag,
    debug_response = {},
    debug_error,
    meta = {},
    force_use_api,
  },
) => {
  if (requestMutation) commit(requestMutation, { meta });
  if (loading_flag) {
    commit('SET_API_LOADING', { flag: loading_flag, loading: true });
  }
  try {
    let response;
    let data;

    if (useApi() || force_use_api) {
      response = await request(method, url, options.data ?? options, options.params);
      data = response.data;
    } else {
      // Simulate network delay
      await sleep(Math.random() * 300);
      if (debug_error) {
        throw debug_error;
      } else {
        response = debug_response;
        data = response;
      }
    }
    if (success) commit(success, { data, meta, response });

    return response;
  } catch (err) {
    if (!(err instanceof ApiError)) throw err;

    const { response } = err;
    const { data = { message: 'Server Error' }, status } = response || {};
    if (error) {
      commit(error, {
        error: err,
        data,
        meta,
        response,
      });
    } else if (globalError) {
      await dispatch('setGlobalApiError');
    }
    return { error: err, data, status };
  } finally {
    if (loading_flag) {
      commit('SET_API_LOADING', { flag: loading_flag, loading: false });
    }
  }
};

const setGlobalApiError: Action<any, any> = ({ commit }) => {
  commit('SET_API_ERROR', API_ERROR);
};

const setGlobalError: Action<any, any> = ({ commit }, error) => {
  commit('SET_API_ERROR', error);
};

const clearGlobalError: Action<any, any> = ({ commit }) => {
  commit('SET_API_ERROR', null);
};

export default {
  apiCall,
  setGlobalApiError,
  setGlobalError,
  clearGlobalError,
};
